import { cn } from '../../lib/cn';
import type { InnovationRow } from '../../enterprisega/framework';

type Props = { items?: InnovationRow[] };

export function InnovationPlatformPanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={`${item.category}-${item.name}`} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="text-xs text-slate-500">{item.category}</p>
              <p className="text-sm font-medium">{item.name}</p>
            </div>
            <span className={cn(
              'shrink-0 rounded-full px-2 py-0.5 text-xs font-medium',
              item.status === 'published' || item.status === 'active' ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300' :
              item.status === 'research' ? 'bg-amber-50 text-amber-700 dark:bg-amber-950 dark:text-amber-300' :
              'bg-brand-50 text-brand-700 dark:bg-brand-950 dark:text-brand-300',
            )}>
              {item.status}
            </span>
          </div>
          <div className="mt-2 h-2 overflow-hidden rounded-full bg-slate-100 dark:bg-slate-800">
            <div
              className="h-full rounded-full bg-brand-500"
              style={{ width: `${item.progress}%` }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
